import { useState } from 'react'

import { fehlertext } from '../../api/client'
import { useMe, useSelbstpruefung, useSicherung } from '../../hooks/queries'
import { useOnline } from '../../hooks/useOutbox'
import { groesse } from '../../lib/format'
import { useTexte } from '../../texte'

/** Mirrors `Backup::MIN_PASSPHRASE`; the server decides, this only counts. */
const MINDESTENS = 12

/**
 * The backup of the installation (#77, 1.74.0): database and `.env` in one
 * ZIP, encrypted with a passphrase the supervisor types here.
 *
 * **The link is a plain link, not `sichereDatei()`.** That one loads the
 * whole file into memory to hand it to the share sheet; a database of a
 * long trip is not something to hold in a phone's memory, and a backup is
 * fetched at a computer anyway, where a download is the normal way.
 *
 * **Whether the server can encrypt, it says in the self-check** -- the card
 * reads the same answer and shows a sentence instead of a button that can
 * only fail.
 */
export function SicherungCard() {
  const texte = useTexte()
  const t = texte.betrieb
  const me = useMe()
  const online = useOnline()
  const pruefung = useSelbstpruefung(me.data?.may_operate === true)
  const sicherung = useSicherung()
  const [passphrase, setPassphrase] = useState('')

  const moeglich = pruefung.data?.backup_encryption !== false
  const lang = [...passphrase].length
  const fertig = sicherung.isSuccess && !sicherung.isPending ? sicherung.data : null

  return (
    <div className="card card--seite" data-sicherung="">
      <p className="card__lead">{t.sicherungLead}</p>

      {!moeglich ? (
        <p className="notice" role="alert" data-sicherung-nicht-moeglich="">
          {t.sicherungNichtMoeglich}
        </p>
      ) : (
        <form
          className="stack"
          onSubmit={(event) => {
            event.preventDefault()
            if (lang >= MINDESTENS && online && !sicherung.isPending) {
              sicherung.mutate(passphrase)
            }
          }}
        >
          <label className="field">
            <span className="field__label">{t.sicherungPassphrase}</span>
            <input
              className="field__input"
              type="password"
              autoComplete="new-password"
              value={passphrase}
              onChange={(event) => setPassphrase(event.target.value)}
              data-sicherung-passphrase=""
            />
            <span className="feld__hinweis">{t.sicherungHinweis(MINDESTENS)}</span>
            <span className="feld__hinweis" data-sicherung-zaehler={lang}>
              {t.sicherungZaehler(lang, MINDESTENS)}
            </span>
          </label>

          {!online && (
            <p className="feld__hinweis" role="alert">
              {texte.allgemein.ohneNetz}
            </p>
          )}
          {sicherung.isError && (
            <p className="notice" role="alert" data-sicherung-fehler="">
              {fehlertext(sicherung.error)}
            </p>
          )}

          <button
            type="submit"
            className="button button--outline button--schmal"
            disabled={lang < MINDESTENS || !online || sicherung.isPending}
            data-sicherung-knopf=""
          >
            {sicherung.isPending ? t.sicherungLaeuft : t.sicherungErstellen}
          </button>
        </form>
      )}

      {fertig !== null && (
        <div className="stack stack--eng" data-sicherung-fertig="">
          <p
            className="platz__zahl platz__zahl--abstand"
            data-sicherung-reisen={fertig.trips}
            data-sicherung-pois={fertig.points}
          >
            {t.sicherungFertig(fertig.tables, fertig.trips, fertig.points, groesse(fertig.bytes))}
          </p>
          <a href={fertig.url} download={fertig.filename} data-sicherung-link="">
            {t.sicherungHolen(fertig.filename)}
          </a>
          <p className="leise">{t.sicherungFrist}</p>
          <p className="leise">{t.sicherungOeffnen}</p>
        </div>
      )}
    </div>
  )
}
